<tc-model-version-grid
  #modelVersionGrid
  [selectedInstance]="instanceElement"
  (selectedSnapshot)="onSelectedSnapshot($event)"
>
</tc-model-version-grid>
